import { Box, Button, SvgIcon, styled } from '@mui/material';
import Input from 'src/frontend-common/components/Input';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';

export const Header = styled(Box)(() => ({
  display: 'flex',
  padding: '16px',
  justifyContent: 'space-between',
}));

export const SearchIconWrapper = styled(SvgIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const SearchInput = styled(Input)(() => ({
  width: '100%',
  maxWidth: 'none !important',
}));

export const CustomLoadingScreen = styled(LoadingScreen)(({ theme }) => ({
  minHeight: '500px',
  backgroundColor: theme.palette.background.paper,
}));

export const CustomButton = styled(Button)(() => ({
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
